/* eslint-disable react/function-component-definition */
/* Global imports. */
import React from "react";
import { nanoid } from 'nanoid';
import { Link } from "gatsby";

/* Model imports. */
import KontentArticleSummary from "@models/kontent/KontentArticleSummary";

/* Imports from within current directory. */
import ArticleCardBackgroundImage from "./ArticleCardBackgroundImage";

interface Props {
  articleSummary: KontentArticleSummary;
  articleURL: string;
  format: "large" | "portrait" | "landscape";
  backgroundColor?: string;
  textColour?: string;
  referringComponentID? : string;
  referringSlug? : string
}

const ArticleCard = ({ articleSummary, articleURL, format, backgroundColor, textColour, referringComponentID, referringSlug }: Props) => {

  const formatLinkClasses = () => {
    switch (format) {
      case "landscape":
        return "flex gap-5 sm:flex-none";
      default:
        return "flex flex-col gap-5";
    }
  };

  const articleCategory = articleSummary && articleSummary.article_categories && articleSummary.article_categories.value[0] && articleSummary.article_categories.value[0].name;
  const articleTitle = articleSummary && articleSummary.title.value
  const articleDate = articleSummary && articleSummary.display_date.value

  return (
    <li
      key={nanoid()}
      className={`list-none transition-colors group bg-[#EEEEEE] hover:!bg-[#EEEEEE] border border-transparent hover:border-grey-dark w-full`}
      style={{backgroundColor: `#${backgroundColor && backgroundColor.replace("#","")}`}}
    >
      <a data-ref-component-id={referringComponentID} data-ref-slug={referringSlug} data-component="article-card" data-format={format} data-category={articleCategory} data-title={articleTitle} data-date={articleDate} href={`/${articleURL}`} className={`${formatLinkClasses()} !no-underline h-full content-start p-5`}>
        <div className={`${format !== 'landscape' ? 'mx-auto w-full h-fit' : 'h-fit w-fit'}`}>
          <ArticleCardBackgroundImage image={articleSummary && articleSummary.image && articleSummary.image.value && articleSummary.image.value[0] && articleSummary.image.value[0].url} format={format} />
        </div>
        <figure className={`font-sans relative self-stretch flex items-center`}>
          <h3 className={` text-base sm:text-xl font-bold font-['sailec'] leading-normal sm:leading-[30px] text-grey-dark`} style={{color: `#${textColour}`}}>
            {articleTitle}
          </h3>
        </figure>
      </a>
    </li>
  );
};

export default ArticleCard;